import axios from 'axios';
import cookies from 'react-cookies';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_REQUEST_ENDPOINT
});
export default api;
